"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timer = void 0;
const date_1 = __importDefault(require("../date"));
const themed_1 = require("@rneui/themed");
const react_1 = __importStar(require("react"));
const constants_1 = require("./constants");
const getTimeRemaining_1 = require("./getTimeRemaining");
const react_native_1 = require("react-native");
const Timer = () => {
    const [remaining, setRemaining] = (0, react_1.useState)((0, getTimeRemaining_1.getTimeRemaining)(constants_1.weddingDate));
    (0, react_1.useEffect)(() => {
        let countdown;
        let timer = setInterval(() => {
            countdown = constants_1.weddingDate.valueOf() - (0, date_1.default)().valueOf();
            setRemaining((0, getTimeRemaining_1.getTimeRemaining)(constants_1.weddingDate));
            if (countdown <= 0) {
                countdown = 0;
                clearInterval(timer);
            }
        }, 1000);
        return () => {
            clearInterval(timer);
        };
    }, []);
    return (react_1.default.createElement(react_native_1.View, { style: styles.container },
        react_1.default.createElement(themed_1.Text, { style: styles.text }, "\u0414\u043E \u0441\u0432\u0430\u0434\u044C\u0431\u044B \u043E\u0441\u0442\u0430\u043B\u043E\u0441\u044C:"),
        react_1.default.createElement(react_native_1.View, { style: styles.timer },
            react_1.default.createElement(themed_1.Text, { style: styles.text },
                "\u0414\u043D\u0435\u0439 ",
                '\n' + remaining.days),
            react_1.default.createElement(themed_1.Text, { style: styles.text },
                "\u0427\u0430\u0441\u043E\u0432 ",
                '\n' + remaining.hours),
            react_1.default.createElement(themed_1.Text, { style: styles.text },
                "\u041C\u0438\u043D\u0443\u0442 ",
                '\n' + remaining.minutes),
            react_1.default.createElement(themed_1.Text, { style: styles.text },
                "\u0421\u0435\u043A\u0443\u043D\u0434 ",
                '\n' + remaining.seconds))));
};
exports.Timer = Timer;
const styles = react_native_1.StyleSheet.create({
    container: {
        backgroundColor: 'rgba(52, 52, 52, 0.8)',
        alignItems: 'center',
        alignSelf: 'center',
        padding: 10,
        borderRadius: 10,
        borderWidth: 2,
        margin: 10,
    },
    timer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
    },
    text: {
        fontSize: 20,
        borderWidth: 1,
        borderRadius: 10,
        margin: 4,
        padding: 8,
        fontFamily: 'Cursive',
    },
});
